<div class="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8" [ngClass]="{'bg-gray-50': !isDarkMode(), 'bg-gray-900': isDarkMode()}">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <img class="mx-auto h-10 w-auto" src="assets/images/meetzy_logo_transparent.png" alt="Logo">
    <h2 class="mt-6 text-center text-2xl font-bold leading-9 tracking-tight" [ngClass]="{'text-gray-900': !isDarkMode(), 'text-gray-100': isDarkMode()}">Reset your password</h2>
  </div>

  <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
    <div class="px-6 py-12 shadow sm:rounded-lg sm:px-12" [ngClass]="{'bg-white': !isDarkMode(), 'bg-gray-800': isDarkMode()}">
      <form class="space-y-6" [formGroup]="resetForm" (ngSubmit)="onSubmit()">
        <div>
          <label for="password" class="block text-base font-medium leading-6" [ngClass]="{'text-gray-900': !isDarkMode(), 'text-gray-100': isDarkMode()}">New Password</label>
          <div class="mt-2">
            <input id="password" name="password" formControlName="password" type="password" placeholder="Enter your new password" required 
              class="text-base block w-full rounded-md border-0 py-4 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600" [ngClass]="{'text-gray-900 ring-gray-300 bg-white': !isDarkMode(), 'text-gray-100 ring-gray-600 bg-gray-700': isDarkMode()}">
          </div>
          <div *ngIf="resetForm.get('password')?.touched && resetForm.get('password')?.errors?.['required']" class="text-red-500 text-sm mt-1">
            Password is required
          </div>
          <div *ngIf="resetForm.get('password')?.touched && resetForm.get('password')?.errors?.['minlength']" class="text-red-500 text-sm mt-1">
            Password must be at least 6 characters long
          </div>
        </div>

        <div>
          <label for="confirmPassword" class="block text-base font-medium leading-6" [ngClass]="{'text-gray-900': !isDarkMode(), 'text-gray-100': isDarkMode()}">Confirm Password</label>
          <div class="mt-2">
            <input id="confirmPassword" name="confirmPassword" formControlName="confirmPassword" type="password" placeholder="Confirm your new password" required 
              class="text-base block w-full rounded-md border-0 py-4 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600" [ngClass]="{'text-gray-900 ring-gray-300 bg-white': !isDarkMode(), 'text-gray-100 ring-gray-600 bg-gray-700': isDarkMode()}">
          </div>
          <div *ngIf="resetForm.get('confirmPassword')?.touched && resetForm.get('confirmPassword')?.errors?.['required']" class="text-red-500 text-sm mt-1">
            Please confirm your password
          </div>
        </div>

        <div>
          <button type="submit" [disabled]="loading || !resetForm.valid" 
            class="flex w-full justify-center bg-emerald-500 rounded-md px-3 py-4 text-lg font-semibold leading-6 text-white shadow-sm hover:bg-emerald-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50 disabled:cursor-not-allowed">
            {{ loading ? 'Resetting...' : 'Reset Password' }}
          </button>

          <div *ngIf="errorMessage" class="mt-2 text-center text-red-500">{{errorMessage}}</div>
          <div *ngIf="successMessage" class="mt-2 text-center text-green-500">{{successMessage}}</div>
        </div>
      </form>

      <div class="mt-6 text-center">
        <a routerLink="/login" class="text-sm font-semibold text-emerald-600 hover:text-emerald-500">
          Back to login
        </a>
      </div>
    </div>
  </div>
</div> 